var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 100,
    viewBox: "0 0 86 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6836 55.2139L48.8633 59.5293L64.8963 80.6932L70.7166 76.3778L54.6836 55.2139Z",
    fill: "#2D4993"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3123 71.4158L61.3222 75.1156C60.2692 75.8964 60.0553 77.3738 60.8445 78.4155L75.7676 98.1144C76.5568 99.1561 78.0502 99.3677 79.1032 98.587L84.0934 94.8871C85.1464 94.1063 85.3603 92.6289 84.5711 91.5872L69.6479 71.8883C68.8588 70.8466 67.3653 70.635 66.3123 71.4158Z",
    fill: "#183171"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1493 65.588C26.5929 65.588 20.1838 63.6646 14.7324 60.061C9.28104 56.4574 5.03228 51.3354 2.52344 45.3429C0.014596 39.3503 -0.641634 32.7564 0.637727 26.3948C1.91709 20.0333 5.07457 14.19 9.71089 9.60383C14.3472 5.01765 20.2541 1.89462 26.6846 0.629683C33.1151 -0.635256 39.7803 0.0147144 45.8374 2.49739C51.8945 4.98007 57.0714 9.18394 60.7133 14.5774C64.3553 19.9708 66.2988 26.3116 66.2981 32.7978C66.287 41.4916 62.7909 49.8261 56.5766 55.9732C50.3622 62.1203 41.9371 65.5781 33.1493 65.588ZM33.1493 3.7595C27.3448 3.7595 21.6707 5.46225 16.8444 8.65244C12.0182 11.8426 8.25649 16.377 6.03505 21.6821C3.81361 26.9873 3.23219 32.825 4.3643 38.457C5.49642 44.089 8.29123 49.2625 12.3953 53.3232C16.4994 57.3839 21.7285 60.1495 27.4213 61.2702C33.1141 62.3909 39.015 61.8165 44.3779 59.6195C49.7407 57.4225 54.3246 53.7017 57.5499 48.9275C60.7752 44.1533 62.4971 38.5401 62.4979 32.7978C62.4899 25.0994 59.3953 17.7186 53.8932 12.2747C48.3912 6.83084 40.9309 3.76846 33.1493 3.7595Z",
    fill: "#183171"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0004 20L22.0005 44",
    stroke: "#183171",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0005 20L46.0004 44",
    stroke: "#183171",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearch);
export default __webpack_public_path__ + "static/media/noSearch.1b7bdb7d1285a0f342cdac2affe8ee20.svg";
export { ForwardRef as ReactComponent };